import { Navigate, useParams, useSearchParams } from 'react-router-dom';

import { PathnameEnum } from '@web/Router/router.types';
import { generatePath } from '@web/Router/router.utils';
import { useGetConversations } from '@web/conversations/hooks/useGetConversations';
import { Conversation } from '@web/conversations/Conversation/Conversation';
import { useGroupConversationsPremiumGuard } from '@web/conversations/hooks/useGroupConversationsPremiumGuard';
import { ConversationLocked } from '@web/conversations/ConversationLocked/ConversationLocked';

export const ConversationRoute = () => {
  const { id: idParam } = useParams();
  const [searchParams] = useSearchParams();
  const selectedMessageId = Number(searchParams.get('messageId')) || null;
  const { data, isError, isLoading } = useGetConversations();
  const { areGroupConversationsEnabled } = useGroupConversationsPremiumGuard();

  if (isError) {
    // @TODO probably 404 is not suitable for every scenario
    return <Navigate to={generatePath(PathnameEnum.ERROR_404)} />;
  }

  if (isLoading) return null;

  const id = idParam ? Number(idParam) : null;
  if (id) {
    const conversation = data?.find((conversation) => conversation.id === id);

    if (!conversation) {
      return <Navigate to={generatePath(PathnameEnum.ERROR_404)} />;
    }

    if (!conversation.isPrivate && !areGroupConversationsEnabled) {
      return <ConversationLocked />;
    }

    return <Conversation id={conversation.id} selectedMessageId={selectedMessageId} />;
  }

  const recentlyActiveConversation = data
    .filter(
      (conversation) =>
        !conversation.isArchived && (areGroupConversationsEnabled || conversation.isPrivate)
    )
    .sort((a, b) => b.newestMessageId - a.newestMessageId)[0];

  if (recentlyActiveConversation) {
    const { id, slug } = recentlyActiveConversation;

    return (
      <Navigate
        replace
        to={generatePath(PathnameEnum.CONVERSATION_DETAILS, {
          params: { id, slug },
        })}
      />
    );
  }

  return <Navigate to={generatePath(PathnameEnum.CONVERSATION_COMPOSE)} />;
};
